import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IMAGES, SITE } from '../data/site';

export default function ThankYou() {
  useEffect(() => {
    document.title = 'Thank You - Phoenix Roofing & Chimney';
  }, []);
  return (
    <div className="py-24 text-center px-4" data-testid="thank-you-page">
      <img src={IMAGES.clap} alt="Thank you" className="h-24 w-auto mx-auto" />
      <h1 className="section-title mt-8">Thank You!</h1>
      <p className="mt-5 text-lg text-foreground/85 max-w-xl mx-auto">
        Your request has been received. Our team will contact you shortly to schedule your free in-house estimate.
      </p>
      <p className="mt-3 text-foreground/85">
        Need immediate help? Call us at <a href={SITE.phoneHref} className="text-primary font-bold">{SITE.phone}</a>
      </p>
      <Link to="/" className="btn-cta mt-9" data-testid="thank-you-home-btn">Back to Home</Link>
    </div>
  );
}
